export function generateIntroHaveMetFeatureIdentifier(matchId: string) {
  return `introduction-havemet-prompt-${matchId}`;
}
